// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SettingsComponent} from './Settings.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSettings = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SettingsComponent/>
  </Icon>
));
